<div class="c-card">
	<div class="c-content">
		<p class="c-text">{{ 'Symptoms.Text1' | translate }}</p>
	</div>
	<div class="c-content">
		<ul class="c-list c-list--square c-list--columns">
			<li class="c-list__item" *ngFor="let symptom of vm.symptoms ; let $index=index">
				<a href="{{ symptom.link }}" *ngIf="symptom.link">{{ symptom.name }}</a>
				<a *ngIf="!symptom.link">{{ symptom.name }}</a>
			</li>
		</ul>
	</div>
	<div class="c-content">
		<p class="c-text">{{ 'Symptoms.Text2' | translate }}</p>
	</div>
</div>
